/**
 * Valores por defecto (coinciden con backend hasta cargar GET /public/booking-config).
 */
export const DEFAULT_BOOKING_SCHEDULE = {
  schedule_start: '12:00',
  schedule_end: '20:00',
  slot_step_minutes: 15,
};

export function parseTimeToMinutes(s) {
  const parts = (s || '00:00').toString().trim().split(':');
  const h = parseInt(parts[0], 10) || 0;
  const m = parseInt(parts[1], 10) || 0;
  return h * 60 + m;
}

/**
 * Lista de "HH:mm" desde schedule_start hasta schedule_end (fin exclusivo), cada stepMinutes.
 */
export function buildHoursByStep(scheduleStart, scheduleEnd, stepMinutes) {
  const start = parseTimeToMinutes(scheduleStart);
  const end = parseTimeToMinutes(scheduleEnd);
  const step = Math.max(1, Number(stepMinutes) || 15);
  const values = [];
  for (let min = start; min < end; min += step) {
    const hh = String(Math.floor(min / 60)).padStart(2, '0');
    const mm = String(min % 60).padStart(2, '0');
    values.push(`${hh}:${mm}`);
  }
  return values;
}

export function formatScheduleLabel(booking) {
  if (!booking?.schedule_start || !booking?.schedule_end) return 'L-S 12:00–20:00';
  return `L-S ${booking.schedule_start}–${booking.schedule_end}`;
}
